module.exports = __webpack_public_path__ + "Sample-Import-Report-M-Bayar.xlsx";